var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('img',{staticClass:"icon mr-2",attrs:{"src":_vm.avatar,"alt":""}}),_c('div',[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }